import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'src/hooks/dataHooks/queryKeys.js';
import { request } from 'src/utilities/axios-utils.js';

//*----------------------------------------------------------------

const fetchAppStatus = async (checkCampaignStatus) => {
  const defaultResponse = { appStatus: {} };

  if (!checkCampaignStatus) {
    return defaultResponse;
  }
  // const response = await request({ url: '/campaign', method: 'GET' });

  const response = await request({
    url: '/campaign',
    method: 'GET',
  });

  if (200 === response.status) {
    return response.data;
  } else {
    return defaultResponse;
  }
};

export const useCheckCampaignStatus = () => {
  const checkCampaignStatus = 'true' === import.meta.env?.VITE_CHECK_CAMPAIGN_STATUS || false;
  return useQuery({
    queryKey: [queryKeys.CHECK_CAMPAIGN_STATUS],
    queryFn: async () => await fetchAppStatus(checkCampaignStatus),
    refetchOnWindowFocus: false,
  });
};
